import React from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { glow, linearGradient } from "../helpers/theme";
import transparentImage from "../img/transparent.jpg";

export default function ThemePreview({ theme }) {
	const { projectId, themeId } = useParams();

	const cloud = useSelector((state) => state.rundown?.cloud);

	const outputBackgroundColour = "transparent"
	const baseTheme = useSelector((state) =>
		cloud ? theme : state.main?.projects?.[projectId].themes?.[themeId]
	);

	// loading
	if (!baseTheme) return null;
	return (
		<>
			<div
				style={{
					backgroundColor: outputBackgroundColour,
					backgroundImage:
						outputBackgroundColour === "transparent"
							? `url(${transparentImage})`
							: "none",
					backgroundSize: "20px",
					fontFamily: previewThemeChecker(baseTheme, "font", "family"),
				}}
				className="rounded relative overflow-hidden aspect-video w-100"
			>
				{/* LOWER THIRD */}
				<PreviewGraphic
					type="lower_third"
					h1="Lower third"
					h2="Line two"
					baseTheme={baseTheme}
					positionCss="flex-col bottom-0 left-0 items-start"
				/>
				{/* MESSAGE */}
				<PreviewGraphic
					type="message"
					h1="Message text"
					baseTheme={baseTheme}
					positionCss="flex-col top-0 right-0"
				/>
				{/* TIME */}
				<PreviewGraphic
					type="time"
					h1="00:01:23"
					h2="Timer"
					baseTheme={baseTheme}
					positionCss="flex-col-reverse top-0 left-0"
				/>
				{/* TICKER */}
				<PreviewGraphic
					type="ticker"
					h1="Ticker"
					h2="Ticker items will appear here"
					baseTheme={baseTheme}
					positionCss="bottom-0 left-0 right-0 items-center space-x-10"
				/>
				{/* SOCIAL
    <PreviewGraphicSocial
        type="social"
        h1="Example social message"
        h2="Here to Record"
        baseTheme={baseTheme}
        positionCss="bottom-0 left-0"
    /> */}
			</div>
		</>
	);
}

const previewThemeChecker = (baseTheme, section, element) => {
	return baseTheme?.[section]?.[element];
};

const PreviewGraphic = ({ baseTheme, type, positionCss, h1, h2 }) => {
	let { themeId } = useParams();
	return (
		<div
			style={{
				background: linearGradient(baseTheme, type, undefined, "background"),
				boxShadow: glow(baseTheme, type, undefined, "background", "glowBlur"),
				transform: `translateX(${
					type === "social" ? "8em" : "0em"
				}) translateY(${
					type === "social" || type === "lower_third" ? "-80%" : "0%"
				})`,
				borderTop: `${
					previewThemeChecker(baseTheme, "border", "sides")?.[0] === "1"
						? baseTheme.border?.size
						: 0
				}vw ${previewThemeChecker(
					baseTheme,
					"border",
					"style"
				)} ${previewThemeChecker(baseTheme, "border", "colour")}`,
				borderBottom: `${
					previewThemeChecker(baseTheme, "border", "sides")?.[1] === "1"
						? baseTheme.border?.size
						: 0
				}vw ${previewThemeChecker(
					baseTheme,
					"border",
					"style"
				)} ${previewThemeChecker(baseTheme, "border", "colour")}`,
				borderLeft: `${
					previewThemeChecker(baseTheme, "border", "sides")?.[2] === "1"
						? baseTheme.border?.size
						: 0
				}vw ${previewThemeChecker(
					baseTheme,
					"border",
					"style"
				)} ${previewThemeChecker(baseTheme, "border", "colour")}`,
				borderRight: `${
					previewThemeChecker(baseTheme, "border", "sides")?.[3] === "1"
						? baseTheme.border?.size
						: 0
				}vw ${previewThemeChecker(
					baseTheme,
					"border",
					"style"
				)} ${previewThemeChecker(baseTheme, "border", "colour")}`,
			}}
			className={`${themeId}_${type} absolute flex

              rounded-${previewThemeChecker(
								baseTheme,
								"background",
								"rounding"
							)}
              
              mx-${previewThemeChecker(baseTheme, "position", "marginX")}
              my-${previewThemeChecker(baseTheme, "position", "marginY")}

              px-${previewThemeChecker(baseTheme, "background", "paddingX")}
              py-${previewThemeChecker(baseTheme, "background", "paddingY")}
              
              ${positionCss}
        `}
		>
			{type === "social" && (
				<span className="absolute" style={{ transform: "translateX(-10em)" }}>
					<div
						style={{
							backgroundImage:
								'url("https://heretorecord.com/s/logo-square.png")',
							backgroundRepeat: "no-repeat",
							backgroundSize: "cover",
							backgroundPosition: "center center",
							width: "9vw",
							height: "9vw",
							display: "table",
							borderRadius: "100%",
						}}
					></div>
				</span>
			)}
			<span
				style={{
					color: previewThemeChecker(baseTheme, "h1", "colour"),
					fontWeight: ["true", true].includes(
						previewThemeChecker(baseTheme, "h1", "bold")
					)
						? "bold"
						: "normal",
					fontStyle: ["true", true].includes(
						previewThemeChecker(baseTheme, "h1", "italic")
					)
						? "italic"
						: "normal",
					textDecoration: ["true", true].includes(
						previewThemeChecker(baseTheme, "h1", "underline")
					)
						? "underline"
						: "none",
				}}
				className={`${themeId}_${type}_large_text ${themeId}_large_text items-center
      text-${previewThemeChecker(baseTheme, "h1", "size")}
   `}
			>
				{h1}
			</span>
			<span
				style={{
					color: previewThemeChecker(baseTheme, "h2", "colour"),
					fontWeight: ["true", true].includes(
						previewThemeChecker(baseTheme, "h2", "bold")
					)
						? "bold"
						: "normal",
					fontStyle: ["true", true].includes(
						previewThemeChecker(baseTheme, "h2", "italic")
					)
						? "italic"
						: "normal",
					textDecoration: ["true", true].includes(
						previewThemeChecker(baseTheme, "h2", "underline")
					)
						? "underline"
						: "none",
				}}
				className={`${themeId}_${type}_small_text ${themeId}_small_text items-center
      text-${previewThemeChecker(baseTheme, "h2", "size")}
   `}
			>
				{h2}
			</span>
		</div>
	);
};
